import { getContentType } from 'libs/content/utils';
export var dependencyToLinkedContent = function dependencyToLinkedContent(dependencyId, dependencyObject) {
  return {
    id: dependencyId,
    label: getContentType(dependencyObject._contentTypeName).getLabel(dependencyObject),
    previewImage: getContentType(dependencyObject._contentTypeName).getPreviewImage(dependencyObject)
  };
};